export const bankData = [
  {
    value: '0',
    label: '全部银行'
  },
  {
    value: '10001',
    label: '平安银行'
  },
  {
    value: '10002',
    label: '花都工行'
  },
  {
    value: '10003',
    label: '中山工行'
  }
]

export const bankTypeMap = {
  10001: '平安银行',
  10002: '花都工行',
  30001: '微信商户',
  10003: '中山工行 '
}

export const wxBankData = [
  {
    value: '3',
    label: '微信商户'
  }
]

// 花都银行对账状态
export const rlStatusData2 = [
  {
    value: '-1',
    label: '全部对账状态'
  },

  {
    value: '8',
    label: '待运营确认'
  },
  {
    value: '0',
    label: '待机构确认'
  },
  {
    value: '5',
    label: '机构驳回'
  },
  {
    value: '3',
    label: '待协会确认'
  },
  {
    value: '6',
    label: '协会驳回'
  },
  {
    value: '4',
    label: '待教育局确认'
  },
  {
    value: '7',
    label: '教育局驳回'
  },
  {
    value: '1',
    label: '已对账'
  }
]
// 平安银行对账状态
export const rlStatusData1 = [
  {
    value: '-1',
    label: '全部对账状态'
  },

  {
    value: '8',
    label: '待运营确认'
  },
  {
    value: '0',
    label: '待机构确认'
  },
  {
    value: '5',
    label: '机构驳回'
  },
  {
    value: '1',
    label: '已对账'
  }
]

// 结算状态
export const stStatusData = [
  {
    value: '-1',
    label: '全部状态'
  },
  {
    value: '1',
    label: '已结算'
  },
  {
    value: '2',
    label: '待结算'
  },
  {
    value: '3',
    label: '结算中'
  }
  // {
  //   value: '0',
  //   label: '未结算'
  // },
  // {
  //   value: '2',
  //   label: '结算中'
  // },
  // {
  //   value: '1',
  //   label: '已结算'
  // }
]
